import React from 'react';
import { SearchIcon, BellIcon, BookmarkIcon, DownloadIcon } from 'lucide-react';
export function DashboardStats() {
  const stats = [{
    id: 1,
    name: "Appels d'offres disponibles",
    value: '1,253',
    icon: SearchIcon,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: 2,
    name: 'Alertes actives',
    value: '3',
    icon: BellIcon,
    color: 'bg-yellow-100 text-yellow-600'
  }, {
    id: 3,
    name: "Appels d'offres favoris",
    value: '12',
    icon: BookmarkIcon,
    color: 'bg-green-100 text-green-600'
  }, {
    id: 4,
    name: 'Téléchargements restants',
    value: '8',
    icon: DownloadIcon,
    color: 'bg-purple-100 text-purple-600'
  }];
  return <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-216">
      {stats.map(stat => <div key={stat.id} className="bg-white overflow-hidden shadow-md rounded-lg" data-id="element-217">
          <div className="px-4 py-5 sm:p-6" data-id="element-218">
            <div className="flex items-center" data-id="element-219">
              <div className={`flex-shrink-0 rounded-md p-3 ${stat.color}`} data-id="element-220">
                <stat.icon className="h-6 w-6" data-id="element-221" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-222">
                <dl data-id="element-223">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-224">
                    {stat.name}
                  </dt>
                  <dd data-id="element-225">
                    <div className="text-lg font-semibold text-gray-900" data-id="element-226">
                      {stat.value}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>)}
    </div>;
}